import { AxiosError, } from 'axios';
import Cookies from 'js-cookie';
import {
    BasicApiException,
    ProductsImageType,
    ProductsOriginalImageType,
} from 'common/types';
import { pipe, replace, toUpper, } from 'ramda';

export const getErrorProperties = <T>(error: AxiosError): BasicApiException<T> => ({
    code: error.response?.status,
    message: error.message,
    data: error.response?.data,
});

/**
 * @example
 * Promise.resolve("Data")
 *  .then(delay(1000))
 *  .then(result => console.info(result));
 */
export const delay = <T>(time: number) => (result: T): Promise<T> => new Promise(resolve => setTimeout(() => resolve(result), time));

const formatNumber = new Intl.NumberFormat('PL', { style: 'currency', currency: 'PLN', });
export const formatCurrency = (number: number) => formatNumber.format(number);
export const convertFromFractionalCurrencyToFullCurrency = (baseDivideUnit: number = 100) => (number: number) => number / baseDivideUnit;

export const formatPrice = pipe<number, number, string>(
    convertFromFractionalCurrencyToFullCurrency(),
    formatCurrency,
);

// @ts-ignore
export const capitalize = replace(/^./, toUpper);
export const snakeToCamel = (string: string) => string.replace(/([-_]\w)/g, g => g[1].toUpperCase());

export const snakeToPascal = pipe<string, string, string>(
    snakeToCamel,
    capitalize,
);

export const makeImagesCollectionToDict = (images: ProductsImageType, image: ProductsOriginalImageType) => ({
    ...images,
    [image.type]: { ...image, },
});

export const convertToCase = (caseType: Function, obj: any): object => {
    if (Array.isArray(obj)) {
        return obj.map(value => convertToCase(caseType, value));
    } else if (obj !== null && obj.constructor === Object) {
        return Object.keys(obj).reduce(
            (result, key) => ({
                ...result,
                [caseType(key)]: convertToCase(caseType, obj[key]),
            }),
            {}
        );
    }

    return obj;
};

export const formatDateToPolish = (date: string | Date | null | undefined) => {
    if (!date) {
        return undefined;
    }

    const preparedData = date instanceof Date ? date : new Date(date);

    return new Intl.DateTimeFormat('pl').format(preparedData);
};

export const runAuthCookieWatcher = (
    callback = (oldCookieValue: string | undefined, currentCookieValue: string | undefined) => {},
    { property = 'X-Authorization', timeout = 1500, } = {}
) => {
    let oldCookieValue = Cookies.get(property);

    const checkCookie = () => {
        const currentCookieValue = Cookies.get(property);

        if (currentCookieValue !== oldCookieValue) {
            callback(oldCookieValue, currentCookieValue);
            oldCookieValue = currentCookieValue;
        }
    };

    return setInterval(checkCookie, timeout);
};
